export function trackSurvicateEvent(eventName: string): void {
    try {
        window._sva?.invokeEvent(eventName);
    } catch (err) {
    }
}
